/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CaseResourceDto } from '../../models/case-resource-dto';

export interface GetCaseResourceByRoleAndBp$Params {
  roleCode: string;
  bpGuid: string;
}

export function getCaseResourceByRoleAndBp(http: HttpClient, rootUrl: string, params: GetCaseResourceByRoleAndBp$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CaseResourceDto>>> {
  const rb = new RequestBuilder(rootUrl, getCaseResourceByRoleAndBp.PATH, 'get');
  if (params) {
    rb.query('roleCode', params.roleCode, {});
    rb.query('bpGuid', params.bpGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CaseResourceDto>>;
    })
  );
}

getCaseResourceByRoleAndBp.PATH = '/case-resources';
